import { EMAIL_REGEX } from "utils/validations.utils";
import InputFormField from "components/input-form-field";
import { useForm, useFormContext } from "react-hook-form";
import type { Patient } from "services/types/patients.type";
import ModalForm from "components/modal-form";
import { useUpdatePatientMutation } from "services/patients";
import { AppointmentFormValues } from "../appointment-form.component";
import {
  setCustomMessage,
  setOpen as setSnackbarOpen,
} from "components/action-snackbar/action-snackbar-slice";
import ErrorSnackbarContent from "components/error-snackbar-content";
import { useAppDispatch } from "app/hooks";
import { useEffect, useMemo } from "react";

interface UpdatePatientEmailModalProps {
  patient: Patient;
  isOpen: boolean;
  onCancel: () => void;
}

const UpdatePatientEmailModal: React.FC<UpdatePatientEmailModalProps> = ({
  patient,
  isOpen,
  onCancel,
}) => {
  const dispatch = useAppDispatch();
  const [updatePatient, { isLoading: isSubmitting }] =
    useUpdatePatientMutation();

  const { setValue } = useFormContext<AppointmentFormValues>();

  const defaultValues = useMemo(
    () => ({ email: patient.email ?? "" }),
    [patient.email]
  );

  const { control, reset, getValues } = useForm<{ email: string }>({
    defaultValues,
  });

  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

  return (
    <ModalForm
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      onCancel={onCancel}
      onSubmit={() =>
        updatePatient({ id: patient.id, email: getValues().email }).then(
          (response) => {
            if ("error" in response) {
              dispatch(
                setCustomMessage(<ErrorSnackbarContent response={response} />)
              );
              dispatch(setSnackbarOpen(true));
            } else {
              setValue("patient.email", response.data.email);
              onCancel();
            }
          }
        )
      }
      title={`Update ${patient.fullName}'s email`}
      hideBackdrop={false}
      formName="product"
      control={control}
      maxWidth="sm"
    >
      <InputFormField
        name="email"
        label="Email"
        control={control}
        rules={{
          pattern: {
            value: EMAIL_REGEX,
            message: "Email is not valid.",
          },
        }}
        sx={null}
      />
    </ModalForm>
  );
};

export default UpdatePatientEmailModal;
